import GridViewCollapase from "src/SharedComponents/GridViewCollapse/GridViewCollapse";
import tableStyles from 'src/Utils/CssModules/table.module.css';
import { IAuraSoftwareSuiteLicensesInfo, IPartner } from "src/Utils/Hooks/useGetAdminInfo/useGetAuraSupportInfo";
import { useEffect, useState } from "react";
import { formatDateString } from "src/Utils/DateFormatting/DateFormatter";
import Button from "src/SharedComponents/Button/Button";
import AssignLicenseToPartner from "../../AssignLicenseToPartner/AssignLicenseToPartner";
import { useDistributorLicenseServiceWrapper } from "src/Utils/Hooks/LicenseService/useDistributorLicenseServiceWrapper";
import { LicenseType } from "src/Utils/Hooks/LicenseService/useDistributorLicenseService";
import { isDateExpired } from "src/Utils/DateExpiry/DateExpiryChecker";
import { getLicenseType } from "src/Utils/Hooks/useGetAdminInfo/LicenseTypeHelper";

export interface IAuraSoftwareSuiteLicensesUnassigned{
    auraSoftwareSuiteLicenses: IAuraSoftwareSuiteLicensesInfo[];
    partners: IPartner[] | undefined;
    updateLicenses: () => void;
}

const AuraSoftwareSuiteLicensesUnassigned: React.FC<IAuraSoftwareSuiteLicensesUnassigned> = ({auraSoftwareSuiteLicenses, partners, updateLicenses}) => {
    const [showAssignPartner, setShowAssignPartner] = useState<boolean>(false);
    const [entitlementId, setEntitlementId] = useState<string>("");

    const { reqestResponse, assignLicensePartner } = useDistributorLicenseServiceWrapper();
        
        useEffect(() => {
            if(reqestResponse) {
                updateLicenses();
            }
        }, [reqestResponse, updateLicenses]);
        

    return(
        <>
            {
                showAssignPartner && 
                <AssignLicenseToPartner
                    onClose={() => {setShowAssignPartner(false)}}
                    onSubmit={(distributorId: string, distributorName: string) => {
                        assignLicensePartner(LicenseType.AuraSoftwareSuiteLicenses,distributorId, [entitlementId], distributorName);
                        setShowAssignPartner(false)
                    }}
                    entitlementId={entitlementId}
                    partners={partners}
                    licenseType="Aura Software Suite"
                />
            }
            <GridViewCollapase title="On Stock" id="aura-software-suite-licenses-unassigned">
                <div>
                    <table style={{ width: '100%' }} data-testid="table" className={`table ${tableStyles.tableStriped}`}>
                        <thead className={`${tableStyles.tableHead}`}>
                            <tr key={'header'}>
                                <th className={tableStyles.heading} style={{width: '20%', paddingTop: '0px'}}>Suite</th>
                                <th className={tableStyles.heading} style={{width: '15%', paddingTop: '0px'}}>Expiration date</th>
                                <th style={{width: '15%', paddingTop: '0px'}}></th>
                                <th style={{width: '20%', paddingTop: '0px'}}></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                auraSoftwareSuiteLicenses.map((license: IAuraSoftwareSuiteLicensesInfo, index: number) => (
                                    <tr key={index}>
                                        <td className={tableStyles.data}>{getLicenseType(license?.licenseType)}</td>
                                        <td className={tableStyles.data} style={isDateExpired(license?.licenseEndDate) ? {color: 'red'} : {}}>{license?.licenseEndDate ? formatDateString(license.licenseEndDate) : '-'}</td>
                                        <td></td>
                                        <td></td>
                                        <td className={tableStyles.data} style={{textAlign: 'end'}}>
                                            <Button
                                                backgroundColor="#A8927D29"
                                                color="#A8927D"
                                                text="Assign to Partner"
                                                borderColor="none"
                                                fontSize="12px"
                                                width='172px'
                                                fontWeight='600'
                                                disable={false}
                                                onClick={() => {setEntitlementId(license?.entitlementId);setShowAssignPartner(true)}}
                                            />
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </GridViewCollapase>
        </>
    );
}

export default AuraSoftwareSuiteLicensesUnassigned;